module.exports = __webpack_public_path__ + "img/Z86_07.8a7e8922.jpg";